import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useCompany } from "@/lib/company";
import { acct, fmtDate, kes, today } from "@/lib/money";
import { Page, Btn, Table, Tr, Td, Field, Loading } from "@/components/kit";
import { download } from "@/lib/download";

const input = "min-h-[40px] rounded-md border border-slate-300 px-2 text-sm text-slate-800";

export default function Ledger() {
  const { aid } = useParams();
  const { company } = useCompany();
  const [from, setFrom] = useState("");
  const [to, setTo] = useState(today());
  const [all, setAll] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (company) api.get(`/companies/${company.id}/reports/ledger/${aid}`, { params: { date_from: from || undefined, date_to: to, show_reversed: all } }).then(({ data: d }) => setData(d));
  }, [company, aid, from, to, all]);
  if (!data) return <Page title="Account"><Loading /></Page>;
  return (
    <Page title={`${data.account.code} ${data.account.name}`} back={{ to: "/accounts", label: "Chart of accounts" }}
      actions={<Btn onClick={() => download(`/companies/${company.id}/exports/ledger/${aid}`, { date_from: from || undefined, date_to: to, show_reversed: all })}>Download Excel</Btn>}>
      <div className="mt-4 flex flex-wrap gap-3">
        <Field label="From"><input type="date" className={input} value={from} onChange={(e) => setFrom(e.target.value)} /></Field>
        <Field label="To"><input type="date" className={input} value={to} onChange={(e) => setTo(e.target.value)} /></Field>
        <label className="flex items-end gap-2 pb-2.5 text-sm">
          <input type="checkbox" checked={all} onChange={(e) => setAll(e.target.checked)} />
          Show reversed entries{!all && data.hidden_reversed ? ` (${data.hidden_reversed} hidden - they cancel out)` : ""}
        </label>
      </div>
      <Table minWidth={760} cols={[{ label: "Date" }, { label: "Ref" }, { label: "Details" }, { label: "Debit", align: "right" }, { label: "Credit", align: "right" }, { label: "Balance", align: "right" }]}
        foot={<tr><td className="px-2 py-2.5" colSpan={5}>Closing balance</td><td className="px-2 py-2.5 text-right tabular-nums">{acct(data.closing)}</td></tr>}>
        <Tr><Td colSpan={5} className="text-slate-500">Opening balance</Td><Td right>{acct(data.opening)}</Td></Tr>
        {data.entries.map((e, i) => (
          <Tr key={i} className={e.reversed ? "text-slate-400" : ""}>
            <Td className="whitespace-nowrap">{fmtDate(e.date)}</Td><Td className="text-slate-500">{e.ref}</Td><Td>{e.journal_memo && e.memo !== e.journal_memo ? <>{e.journal_memo}<span className="block text-xs text-slate-500">{e.memo}</span></> : e.memo}</Td>
            <Td right>{e.debit ? kes(e.debit) : ""}</Td><Td right>{e.credit ? kes(e.credit) : ""}</Td><Td right>{acct(e.balance)}</Td>
          </Tr>
        ))}
      </Table>
    </Page>
  );
}
